angular.module('lsnBase.md5', []);